import { api } from "./http";
import type { ChatShare, Project, PromptTemplate, SharedChat, TemplateCategory } from "./types";

export const projectsApi = {
  list: () => api<{ projects: Project[] }>("/api/projects").then((r) => r.projects),
  create: (name: string, instructions = "") =>
    api<{ project: Project }>("/api/projects", { method: "POST", json: { name, instructions } }).then((r) => r.project),
  update: (id: string, patch: { name?: string; instructions?: string }) =>
    api<{ project: Project }>(`/api/projects/${id}`, { method: "PATCH", json: patch }).then((r) => r.project),
  remove: (id: string) => api<void>(`/api/projects/${id}`, { method: "DELETE" }),
};

export type TemplateInput = { title: string; body: string; description: string; category: TemplateCategory; attach: boolean };

export const templatesApi = {
  list: () => api<{ templates: PromptTemplate[] }>("/api/templates").then((r) => r.templates),
  create: (t: TemplateInput) => api<{ template: PromptTemplate }>("/api/templates", { method: "POST", json: t }).then((r) => r.template),
  update: (id: string, t: TemplateInput) =>
    api<{ template: PromptTemplate }>(`/api/templates/${id}`, { method: "PUT", json: t }).then((r) => r.template),
  remove: (id: string) => api<void>(`/api/templates/${id}`, { method: "DELETE" }),
};

export const sharesApi = {
  get: (chatId: string) => api<{ share: ChatShare | null }>(`/api/chats/${chatId}/share`).then((r) => r.share),
  publish: (chatId: string) => api<{ share: ChatShare }>(`/api/chats/${chatId}/share`, { method: "PUT" }).then((r) => r.share),
  revoke: (chatId: string) => api<void>(`/api/chats/${chatId}/share`, { method: "DELETE" }),
  open: (token: string) => api<SharedChat>(`/api/shared/${encodeURIComponent(token)}`),
};

/** Полная ссылка для коллег. В демо маршрут живёт в #. */
export const shareUrl = (token: string) =>
  import.meta.env.VITE_DEMO ? `${location.origin}${location.pathname}#/s/${token}` : `${location.origin}/s/${token}`;
